import { findActionPlanForRoute, getActionPlanSubjectSlug } from '@features/action-plans/helpers';
import { studentActionPlansQueryOptions } from '@features/action-plans/queries';
import { createFileRoute, notFound, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_layout/students/$studentNo/action-plans/academic-support/')({
    loader: async ({ context, params }) => {
        const actionPlans = await context.queryClient.ensureQueryData(studentActionPlansQueryOptions(params.studentNo));
        const actionPlan = findActionPlanForRoute(actionPlans, 'academic-support');

        if (!actionPlan) {
            throw notFound();
        }

        const subjectSlug = getActionPlanSubjectSlug(actionPlan);
        if (!subjectSlug) {
            throw notFound();
        }

        throw redirect({
            to: '/students/$studentNo/action-plans/academic-support/$subjectSlug',
            params: {
                studentNo: params.studentNo,
                subjectSlug,
            },
        });
    },
});
